export const CodecValues = [
  { id: 1, name: 'gsm' },
  { id: 2, name: 'alaw' },
  { id: 3, name: 'g729' },
  { id: 4, name: 'ulaw' }
];
